const DeviceMonitor = () => import('Views/device/device-monitor');

export default[
  { path: '/device-monitor', component: DeviceMonitor },
];



// WEBPACK FOOTER //
// ./src/router/deviceMonitor.js